import Head from "@/Molecules/Inertia/Head";
import {usePage} from "@inertiajs/react";
import React, {useEffect, useState} from "react";
import {CommercialPageType} from "@/Atoms/Commercial";
import UpButton from "@/Molecules/UpButton/UpButton";
import {MetaTag} from "@/types/MetaTab";
import Header, {HeaderAuthProps} from "@/Organisms/Header/Header";
import Footer from "@/Organisms/Footer/Footer";
import useNMO from "@/helpers/useNMO";


export default ({children, title, fullTitle, metaTags: clientMetaTags, pageType, adUnit, mobileScaling}: {
  children: any,
  title?: string,
  fullTitle?: string,
  metaTags?: MetaTag[]
  pageType?: CommercialPageType,
  adUnit?: string,
  mobileScaling?: number,
}) => {


  const pageData = usePage(); // inertia hook
  // }
  const {url, component, props} = pageData;
  const metaArray = typeof props.meta === 'object' && !Array.isArray(props.meta) ? [props.meta] : props.meta;
  const auth: HeaderAuthProps = props.auth as HeaderAuthProps;

  const httpEquivKeys = [
    'refresh',
    'content-type',
    'content-security-policy',
    'cache-control',
    'pragma',
    'expires',
  ]
  const metaTags = [...(clientMetaTags ?? []), ...(metaArray as MetaTag[] ?? [])].map((meta) => {
    const [key, value] = Object.entries(meta)[0];
    const keyName = httpEquivKeys.includes(key) ? 'http-equiv' : 'name'
    return {
      content: value,
      [keyName]: key
    }
  });
  // const {initKaching, destroyKaching} = useKaChing();

  useEffect(() => {

    // NMO Comscore (ScorecardResearch)
    const isLoggedIn = !!auth
    const isHome = !!props.homepage
    useNMO({isHome, isLoggedIn})

    // KaChing ads
    const pageTypeValue = pageType || CommercialPageType.Detail;
    if (adUnit) {
      setTimeout( () => {
        // initKaching(url, pageTypeValue, adUnit, mobileScaling)
      }, 1)// render a frame later to allow react based ads to be detected
    }


    return () => {
      // destroyKaching();
    };

  }, []);


  if (fullTitle) {
    title = fullTitle
  } else {
    const appName = import.meta.env.VITE_APP_NAME || 'Mensenlinq';
    title = `${title} - ${appName}`
  }

  return <>
    <Head>
      <title>{title}</title>
      {metaTags && metaTags.map((props, index) =>
        <meta key={index} {...props} />
      )}
    </Head>
    <Header auth={auth}/>
    {children}
    <UpButton/>
    <Footer />
  </>
}
